import { HorizontalContainer } from '@american-autonomy/ag-ui';

import DropdownMenuItemContainer from 'components/DropdownMenuItemContainer';
import CheckmarkIcon from 'components/icons/CheckmarkIcon';
import DropdownText from 'components/text/DropdownText';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const DataTableDropdownMenuItem: FunctionComponent<Props> = ({
    className = '',
    icon = null,
    isActive,
    onClick,
    testId = TEST_ID,
    text
}) => {
    const activeStyles = isActive ? styles.active : '';

    return (
        <DropdownMenuItemContainer
            className={`${className} ${activeStyles}`}
            isActive={isActive}
            key={text}
            onClick={onClick}
            testId={testId}>
            <HorizontalContainer className={styles.horizontalContainer}>
                {icon}

                <DropdownText className={`${activeStyles} ${styles.dropdownText}`} text={text} />
            </HorizontalContainer>

            {isActive && <CheckmarkIcon className={styles.checkmark} />}
        </DropdownMenuItemContainer>
    );
};

export default DataTableDropdownMenuItem;
